import React from "react";
import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";
import {
  routerAnimationExit,
  routerAnimationFrom,
  routerAnimationTo,
  routerAnimationTransition,
  serviceOneFrom,
  serviceOneTo,
  serviceOneTransition,
  topTitleFrom,
  topTitleTo,
  topTitleTransition,
} from "../../hooks/animations";
import "./myteam.css";
import { AiFillLinkedin } from "react-icons/ai";
import { BsGithub, BsTwitter } from "react-icons/bs";
import { FaFacebookF } from "react-icons/fa";
import { SiWebauthn } from "react-icons/si";

const MyTeam = () => {
  return (
    <motion.div
      initial={routerAnimationFrom}
      animate={routerAnimationTo}
      transition={routerAnimationTransition}
      exit={routerAnimationExit}
      className="pt-24 pb-5 min-h-screen container mx-auto"
    >
      <Helmet>
        <title>Who with me - Siam</title>
      </Helmet>
      <motion.div initial={topTitleFrom} animate={topTitleTo} transition={topTitleTransition}>
        <h1 className=" text-center sm:mb-10 mb-5 ">
          <span className="text-accent text-4xl title-font myTeam-title relative z-30">Who With Me</span>
        </h1>
        <p className="text-center italic text-primary">Here is My Companions short overview! </p>
      </motion.div>
      <motion.div
        initial={serviceOneFrom}
        animate={serviceOneTo}
        transition={serviceOneTransition}
        className="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 my-10 gap-5 justify-between "
      >
        <div class="member-card sm:h-[450px] overflow-hidden flex justify-center items-center bg-neutral text-neutral-content relative rounded-2xl">
          <div class="pt-10 sm:pt-0">
            <div className="flex flex-col justify-center items-center">
              <div class="avatar ">
                <div class="w-36 rounded-full  border-4 border-accent effected-border">
                  <img src="https://i.ibb.co/BshM3cc/Mohammad-Ali-Profile-Square.png" />
                </div>
              </div>
              <h1 className="text-4xl font-extrabold text-center mt-5">Mohammad Ali</h1>
              <p className="text-md font-semibold">(Friend)</p>
              <p className="text-xl font-semibold text-center mt-3 h-[100px]">Web Designer & Developer</p>
            </div>
          </div>
          <footer className="effected-footer absolute bottom-0  h-14 w-full bg-primary">
            <div className="flex justify-center pt-2 items-center text-base-100 gap-3">
              <a
                target="_blank"
                className="text-xl p-3 cursor-pointer bg-neutral text-accent hover:text-neutral hover:bg-accent rounded-full transition duration-500 "
                href="https://www.facebook.com/itsproali"
              >
                <FaFacebookF />
              </a>
              <a
                target="_blank"
                className="text-xl p-3 cursor-pointer bg-neutral text-accent hover:text-neutral hover:bg-accent rounded-full transition duration-500 "
                href="https://twitter.com/itsproali"
              >
                <BsTwitter />
              </a>
              <a
                target="_blank"
                className="text-xl p-3 cursor-pointer bg-neutral text-accent hover:text-neutral hover:bg-accent rounded-full transition duration-500 "
                href="https://github.com/itsproali"
              >
                <BsGithub />
              </a>
              <a
                className="text-xl p-3 cursor-pointer bg-neutral text-accent hover:text-neutral hover:bg-accent rounded-full transition duration-500 "
                href="https://www.linkedin.com/in/itsproali/"
              >
                <AiFillLinkedin />
              </a>
            </div>
          </footer>
        </div>
        <div class="member-card sm:h-[450px] overflow-hidden flex justify-center items-center bg-neutral text-neutral-content relative rounded-2xl">
          <div class="pt-10 sm:pt-0">
            <div className="flex flex-col justify-center items-center">
              <div class="avatar ">
                <div class="w-36 rounded-full  border-4 border-accent effected-border">
                  <img src="https://i.ibb.co/1bVhXS7/sakib.png" />
                </div>
              </div>
              <h1 className="text-4xl font-extrabold text-center mt-5">Akram Sakib</h1>
              <p className="text-md font-semibold">(Friend)</p>
              <p className="text-xl font-semibold text-center mt-3 h-[100px]">Full Stack Developer</p>
            </div>
          </div>
          <footer className="effected-footer absolute bottom-0  h-14 w-full bg-primary">
            <div className="flex justify-center pt-2 items-center text-base-100 gap-3">
              <a
                target="_blank"
                className="text-xl p-3 cursor-pointer bg-neutral text-accent hover:text-neutral hover:bg-accent rounded-full transition duration-500 "
                href="https://www.facebook.com/akramSakibA"
              >
                <FaFacebookF />
              </a>
              <a
                target="_blank"
                className="text-xl p-3 cursor-pointer bg-neutral text-accent hover:text-neutral hover:bg-accent rounded-full transition duration-500 "
                href="https://twitter.com/AkramSakib4"
              >
                <BsTwitter />
              </a>
              <a
                target="_blank"
                className="text-xl p-3 cursor-pointer bg-neutral text-accent hover:text-neutral hover:bg-accent rounded-full transition duration-500 "
                href="https://github.com/Akram-Sakib"
              >
                <BsGithub />
              </a>
              <a
                target="_blank"
                className="text-xl p-3 cursor-pointer bg-neutral text-accent hover:text-neutral hover:bg-accent rounded-full transition duration-500 "
                href="https://www.linkedin.com/in/akram-sakib-a7742a214/"
              >
                <AiFillLinkedin />
              </a>
            </div>
          </footer>
        </div>
        <div class="member-card sm:h-[450px] overflow-hidden flex justify-center items-center bg-neutral text-neutral-content relative rounded-2xl">
          <div class="pt-10 sm:pt-0">
            <div className="flex flex-col justify-center items-center">
              <div class="avatar ">
                <div class="w-36 rounded-full  border-4 border-accent effected-border">
                  <img src="https://i.ibb.co/S3mgCbX/nasim.jpg" />
                </div>
              </div>
              <h1 className="text-4xl font-extrabold text-center mt-5">Nasimur Rahman</h1>
              <p className="text-md font-semibold">(Friend)</p>
              <p className="text-xl font-semibold text-center mt-3 h-[100px]">Project Manager</p>
            </div>
          </div>
          <footer className="effected-footer absolute bottom-0  h-14 w-full bg-primary">
            <div className="flex justify-center pt-2 items-center text-base-100 gap-3">
              <a
                target="_blank"
                className="text-xl p-3 cursor-pointer bg-neutral text-accent hover:text-neutral hover:bg-accent rounded-full transition duration-500 "
                href="https://www.facebook.com/nasimur.rahman.5209"
              >
                <FaFacebookF />
              </a>
              <a
                target="_blank"
                className="text-xl p-3 cursor-pointer bg-neutral text-accent hover:text-neutral hover:bg-accent rounded-full transition duration-500 "
                href="https://github.com/NasimurRahman"
              >
                <BsTwitter />
              </a>
              <a
                target="_blank"
                className="text-xl p-3 cursor-pointer bg-neutral text-accent hover:text-neutral hover:bg-accent rounded-full transition duration-500 "
                href="https://www.facebook.com/checkiamsiam/"
              >
                <BsGithub />
              </a>
              <a
                target="_blank"
                className="text-xl p-3 cursor-pointer bg-neutral text-accent hover:text-neutral hover:bg-accent rounded-full transition duration-500 "
                href="https://www.facebook.com/checkiamsiam/"
              >
                <AiFillLinkedin />
              </a>
            </div>
          </footer>
        </div>
        <div class="member-card sm:h-[450px] overflow-hidden flex justify-center items-center bg-neutral text-neutral-content relative rounded-2xl">
          <div class="pt-10 sm:pt-0">
            <div className="flex flex-col justify-center items-center">
              <div class="avatar ">
                <div class="w-36 rounded-full  border-4 border-accent effected-border">
                  <img src="https://i.ibb.co/tBNn8dg/sami-seo.jpg" />
                </div>
              </div>
              <h1 className="text-4xl font-extrabold text-center mt-5">Ilias Sami</h1>
              <p className="text-md font-semibold">(Friend)</p>
              <p className="text-xl font-semibold text-center mt-3 h-[100px]">Technical SEO Expert</p>
            </div>
          </div>
          <footer className="effected-footer absolute bottom-0  h-14 w-full bg-primary">
            <div className="flex justify-center pt-2 items-center text-base-100 gap-3">
              <a
                target="_blank"
                className="text-xl p-3 cursor-pointer bg-neutral text-accent hover:text-neutral hover:bg-accent rounded-full transition duration-500 "
                href="https://www.facebook.com/ilias.sami.3699"
              >
                <FaFacebookF />
              </a>
              <a
                target="_blank"
                className="text-xl p-3 cursor-pointer bg-neutral text-accent hover:text-neutral hover:bg-accent rounded-full transition duration-500 "
                href="https://github.com/NasimurRahman"
              >
                <BsTwitter />
              </a>
              <a
                target="_blank"
                className="text-xl p-3 cursor-pointer bg-neutral text-accent hover:text-neutral hover:bg-accent rounded-full transition duration-500 "
                href="https://iliasslifestyle.wordpress.com/"
              >
                <SiWebauthn />
              </a>
              <a
                target="_blank"
                className="text-xl p-3 cursor-pointer bg-neutral text-accent hover:text-neutral hover:bg-accent rounded-full transition duration-500 "
                href="https://www.linkedin.com/in/ilias-sami/"
              >
                <AiFillLinkedin />
              </a>
            </div>
          </footer>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default MyTeam;
